import React, { useEffect, useState } from "react";
import "./CreateTemplateModal.css";

export default function CreateTemplateModal({
  open,
  onClose,
  onSaved,
  initialTemplate = null,
  mode = "create",
}) {
  const [sample, setSample] = useState("");
  const [name, setName] = useState("");
  const [indexes, setIndexes] = useState([{ key: "", description: "" }]);

  useEffect(() => {
    if (!open) return;
    setSample(initialTemplate?.sample || "");
    setName(initialTemplate?.name || "");
    if (initialTemplate?.indexes?.length) {
      setIndexes(initialTemplate.indexes.map((f) => ({ key: f.key || "", description: f.description || "" })));
    } else {
      setIndexes([{ key: "", description: "" }]);
    }
  }, [open, initialTemplate]);

  if (!open) return null;

  const addField = () => setIndexes([...indexes, { key: "", description: "" }]);
  const updateField = (idx, type, value) => {
    const clone = [...indexes];
    clone[idx][type] = value;
    setIndexes(clone);
  };
  const removeField = (idx) => {
    setIndexes(indexes.filter((_, i) => i !== idx));
  };

  const handleSubmit = async () => {
    if (!sample || !name) {
      alert("Sample và Tên Template không được để trống");
      return;
    }

    const cleanIndexes = indexes.filter(f => f.key && f.description);

    const payload = { sample, name, indexes: cleanIndexes };

    const isEdit = mode === "edit" && initialTemplate?._id;
    const url = isEdit
      ? `https://api.ocr.cybertech.com.vn/packages/${initialTemplate._id}`
      : "https://api.ocr.cybertech.com.vn/packages";
    const method = isEdit ? "PATCH" : "POST";

    try {
      const res = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const data = await res.json();

      if (!res.ok) return alert(data.detail || "Lỗi tạo template");
      onSaved?.(data);
      onClose();
    } catch (err) {
      alert("Lỗi kết nối server");
    }
  };

  return (
    <div className="ctm-overlay">
      <div className="ctm-box">
        <div className="ctm-header">
          <h3>{mode === "edit" ? "Sửa Template" : "Tạo Template mới"}</h3>
          <button className="ctm-close-btn" onClick={onClose}>×</button>
        </div>

        <div className="ctm-body">
          <label>Sample</label>
          <input
            className="ctm-input"
            value={sample}
            onChange={(e) => setSample(e.target.value)}
            placeholder="VD: VN_CCCD"
          />

          <label>Tên Template</label>
          <input
            className="ctm-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="VD: Căn cước công dân"
          />

          <label>Danh sách chỉ mục</label>

          {/* Scroll riêng */}
          <div className="ctm-fields-scroll">
            {indexes.map((f, idx) => (
              <div key={idx} className="ctm-field-row">
                <input
                  className="ctm-input small"
                  placeholder="key"
                  value={f.key}
                  onChange={(e) => updateField(idx, "key", e.target.value)}
                />

                <input
                  className="ctm-input"
                  placeholder="description"
                  value={f.description}
                  onChange={(e) =>
                    updateField(idx, "description", e.target.value)
                  }
                />

                <button className="ctm-remove-btn" onClick={() => removeField(idx)}>
                  ✕
                </button>
              </div>
            ))}
          </div>

          <button className="ctm-add-btn" onClick={addField}>
            + Thêm field
          </button>
        </div>

        <div className="ctm-footer">
          <button className="ctm-btn cancel" onClick={onClose}>
            Hủy
          </button>
          <button className="ctm-btn primary" onClick={handleSubmit}>
            Tạo Template
          </button>
        </div>
      </div>
    </div>
  );
}
